import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import GameTask from '../index';
import Loader from '../../../ui/Loader';
import { useSelector } from 'react-redux';
import { selectGameResults } from '../../../store/slices/rallyGame';
import { generateTaskRoutePath } from '../../../helpers';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { useNavigate } from 'react-router-dom';
const GameTaskWrapper = ({ pathId, isLinearRally, taskInfo, taskResult, selectionTaskAnswers, onSelectionTaskAnswerButtonClick, inputTaskAnswer, onInputTaskAnswerChange, uploadPhotoTaskAnswer, onUploadPhotoTaskAnswerChange, onTargetLocationCheckedIn, showTaskResult, onTryAgainButtonClick, taskAnswerValidationErrors, showLoader, }) => {
    const navigate = useNavigate();
    const gameTaskResults = useSelector(selectGameResults);
    const [isTaskAvailable, setIsTaskAvailable] = useState(!isLinearRally);
    useEffect(() => {
        if (isLinearRally) {
            if (taskInfo && gameTaskResults) {
                const prevTask = gameTaskResults[taskInfo.sorting - 2];
                const isTaskAvailable = !prevTask ||
                    !prevTask.answerType ||
                    prevTask.status === 'completed' ||
                    (prevTask.answerType === 'location' && prevTask.status === 'skipped');
                if (isTaskAvailable) {
                    setIsTaskAvailable(true);
                }
                else {
                    const availableTask = gameTaskResults.find((task) => task.status !== 'completed');
                    if (availableTask) {
                        navigate(generateTaskRoutePath(APP_ROUTES.rallyGamePlay, pathId, availableTask.sorting));
                    }
                    else {
                        generateTaskRoutePath(APP_ROUTES.rallyGamePlay, pathId, 1);
                    }
                }
            }
        }
    }, [taskInfo, gameTaskResults]);
    return isTaskAvailable ? (_jsx(GameTask, { taskInfo: taskInfo, taskResult: taskResult, selectionTaskAnswers: selectionTaskAnswers, onSelectionTaskAnswerButtonClick: onSelectionTaskAnswerButtonClick, inputTaskAnswer: inputTaskAnswer, onInputTaskAnswerChange: onInputTaskAnswerChange, uploadPhotoTaskAnswer: uploadPhotoTaskAnswer, onUploadPhotoTaskAnswerChange: onUploadPhotoTaskAnswerChange, onTargetLocationCheckedIn: onTargetLocationCheckedIn, showTaskResult: showTaskResult, onTryAgainButtonClick: onTryAgainButtonClick, taskAnswerValidationErrors: taskAnswerValidationErrors, showLoader: showLoader })) : (_jsx(Loader, {}));
};
export default GameTaskWrapper;
